import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import Depot from '../../../../_shared/depot';
import { setMultipleRefs } from '../../../../_shared/helpers';
import Overlay from '../../../shared/Overlay';
import { isDialogSupported } from '../../../shared/helpers';
const BubbleAsDialogWithoutRef = ({ visible, isLargeViewport, innerRef, bubbleId, headerId, largeViewportWrapperClasses, overlayClasses, bubbleClasses, onShow, onClose, className, ...commonProps }) => {
    // Refs
    const dialogRef = useRef(null);
    const wasPreviouslyVisible = useRef(false);
    useEffect(() => {
        if ((dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) && isDialogSupported)
            if (visible) {
                if (!wasPreviouslyVisible.current) {
                    wasPreviouslyVisible.current = true;
                }
                onShow === null || onShow === void 0 ? void 0 : onShow();
                dialogRef.current.show();
            }
            else {
                if (wasPreviouslyVisible.current) {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    wasPreviouslyVisible.current = false;
                }
                dialogRef.current.close();
            }
    }, [onClose, onShow, visible]);
    // Derived values
    const dialogProps = {
        innerRef: setMultipleRefs([innerRef, dialogRef]),
        id: bubbleId,
        'aria-hidden': false,
        testId: 'content-wrapper',
        ...commonProps,
    };
    // Classes
    const bubbleAsDialogClasses = clsx(largeViewportWrapperClasses, className, overlayClasses);
    return (React.createElement(React.Fragment, null, isLargeViewport ? (Depot.createElement('dialog', {
        className: bubbleAsDialogClasses,
        ...dialogProps,
    })) : (React.createElement(Overlay, { "aria-labelledby": headerId, className: overlayClasses }, Depot.createElement('dialog', {
        className: bubbleClasses,
        ...dialogProps,
    })))));
};
const BubbleAsDialog = Depot.withRef(BubbleAsDialogWithoutRef);
BubbleAsDialog.displayName = 'BubbleAsDialog';
const BubbleAsDivWithoutRef = ({ isLargeViewport, bubbleId, headerId, largeViewportWrapperClasses, overlayClasses, bubbleClasses, className, ...commonProps }) => {
    // Derived values
    const divProps = {
        id: bubbleId,
        'aria-hidden': false,
        role: 'dialog',
        testId: 'content-wrapper',
        ...commonProps,
    };
    // Classes
    const bubbleAsDivClasses = clsx(largeViewportWrapperClasses, className);
    return (React.createElement(React.Fragment, null, isLargeViewport ? (Depot.createElement('div', {
        className: bubbleAsDivClasses,
        ...divProps,
    })) : (React.createElement(Overlay, { "aria-labelledby": headerId, className: overlayClasses }, Depot.createElement('div', {
        className: bubbleClasses,
        ...divProps,
    })))));
};
const BubbleAsDiv = Depot.withRef(BubbleAsDivWithoutRef);
BubbleAsDiv.displayName = 'BubbleAsDiv';
const Bubble = ({ as }) => {
    if (as === 'dialog') {
        return BubbleAsDialog;
    }
    else {
        return BubbleAsDiv;
    }
};
export default Bubble;
//# sourceMappingURL=index.js.map